export default "__VITE_PUBLIC_ASSET__6109aa09__"